import React, { useEffect } from "react";
import {  Box, InputLabel, Typography } from "@mui/material";
import { FormHelperText } from "@material-ui/core";
import MDButton from "./../../../components/MDButton/index";
import Grid from "@mui/material/Grid";
import { useState } from "react";
import SelectDropDown from "./../../../examples/DropDown/index";
import Checkbox from "@mui/material/Checkbox";
import { FormControlLabel, FormGroup } from "@mui/material";
import MDInput from "components/MDInput";
import { useForm, Controller } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import adminPanelValidation, {
  adminUserDialogValidation,
} from "../../../util/validations/adminPanelValidation";
import { getValue } from "@mui/system";
import { addAdminUser } from "../Redux/actionCreator";
import { useDispatch, useSelector } from "react-redux";
import { setRoleType } from "layouts/events/Redux/actionCreator";
import SelectDropDownNew from "examples/DropDownNew";
import "./create-admin-modal.css"
import { de } from "date-fns/locale";

// const MODULES = [
//   {
//     name: 'Common',
//     items: [
//       { id: 'jobdescription', name: 'Job Description', level: 1 },
//       { id: 'additionaltraining', name: 'Additional Training', level: 1 },
//       { id: 'cities', name: 'Cities', level: 1 },
//       { id: 'companytype', name: 'Company Type', level: 1 },
//       { id: 'departmenttypes', name: 'Department Types', level: 1 },
//       { id: 'documenttypes', name: 'Document Types', level: 1 },
//       { id: 'languages', name: 'Languages', level: 1 },
//       { id: 'experience', name: 'Experience', level: 1 },
//       { id: 'specialization', name: 'Specialization', level: 1 },
//       { id: 'professionalregistrationtypes', name: 'Professional Registration Types', level: 1 },
//       { id: 'profession', name: 'Profession', level: 1 },
//       { id: 'qualifications', name: 'Qualifications', level: 1 },
//       { id: 'software', name: 'Software', level: 1 },
//       { id: 'additionalSkills', name: 'Additional skills', level: 1 },
//       { id: 'gccDepartment', name: 'International Department', level: 1 },
//       { id: 'gccExperience', name: 'International Experience', level: 1 },
//     ]
//   },
//   {
//     module: "Events",
//     items: [
//      { id:'events',name: "Events List" , level:1},
//       { id:'Interview',name: "Interview" , level:1},
//       { id:'referral',name: "Referral" , level:1},
//     ],
//   },
//   {
//     module: "Hospital",
//     items: [
//      { id:'corporate',name: "Corporate" , level:1},
//      { id:'company',name: "Company" , level:1},
//      { id:'branch',name: "Branch" , level:1},
//      { id:'department',name: "Department" , level:1},
//      { id:'rates',name: "Rates" , level:1},
//     ],
//   },
//   {
//     module: "Locum Job",
//     items: [
//       { id:'application',name: "Application" , level:1},
//       { id:'locumJobs',name: "Locum Jobs" , level:1},
//       { id:'shiftLogs',name: "Shift Logs" , level:1},
//     ],
//   },
//   {
//     module: "Permanent Job",
//     items: [
//       { id:'permanentapplication',name: "Application" , level:1},
//       { id:'Job',name: "Job" , level:1},
//     ],
//   },
//   {
//     module: "Credit Limit",
//     items: [
//       { id:'creditLimit',name: "Credit Limit" , level:1},
//     ],
//   },
//   {
//     module: "Users",
//     items: [
//       { id:'nurseHospitalUser',name: "Nurse Hospital User" , level:1},
//       { id:'preSignUpUser',name: "PreSign Up User" , level:1},
//       { id:'premiumUser',name: "Premium User" , level:1},
//       { id:'documentVerification',name: "Document Verification" , level:1},
//       { id:'orwinCandidates',name: "Orwin Candidates" , level:1},
//     ],
//   },
//   {
//     name: 'Billing',
//     items: [
//       { id: 'bill_of_supply', name: 'Bill of Supply', level: 1 }
//     ]
//   },
//   {
//     name: 'Locum Invoices',
//     items: [
//       { id: 'professional_invoice', name: 'Professional Invoice', level: 1 },
//       { id: 'finance_approval', name: 'Finance Approval', level: 2, parent: 'professional_invoice' },
//       { id: 'ops_approval', name: 'Ops Approval', level: 2, parent: 'professional_invoice' },
//       { id: 'professional_tax_invoice', name: 'Professional Tax Invoice', level: 1 },
//       { id: 'bank_details', name: 'Bank Details', level: 1 }
//     ]
//   },
//   {
//     name: 'Availability',
//     items: [
//       { id: 'availability', name: 'Availability', level: 1 }
//     ]
//   },
//   {
//     name: 'Monetization',
//     items: [
//       { id: 'monetization_mlp', name: 'Monetization MLP', level: 1 }
//     ]
//   }
// ];
const AddAdminUserDialogContent = ({ handleDialogClose }) => {
  const[role,setRole]=useState();
  const [expandedModules, setExpandedModules] = useState({});
  const toggleModule = (module) => {
    setExpandedModules((prev) => ({
      ...prev,
      [module]: !prev[module],
    }));
  };
  

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
  })

  const [permissions, setPermissions] = useState([])

  const handleFormChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }
  const handlePermissionChange = (key) => {
    setPermissions((prev) => {
      const updated = { ...prev };
      const isChecked = !updated[key];
      updated[key] = isChecked;
  
      const parts = key.split("_");
      const action = parts.pop(); // view, edit, export
      const baseKey = parts.join("_");
  
      // Auto-select view when edit/export selected
      if ((action === "edit" || action === "export") && isChecked) {
        updated[`${baseKey}_view`] = true;
      }
  
      // Unselect edit/export when view unchecked
      if (action === "view" && !isChecked) {
        updated[`${baseKey}_edit`] = false;
        updated[`${baseKey}_export`] = false;
// Uncheck approval checkboxes when view unchecked
      if (baseKey.includes("professional_invoice")) {
        updated[`${baseKey}_ops_approval_edit`] = false;
        updated[`${baseKey}_finance_approval_edit`] = false;
      }
    }

    // ✅ Uncheck only submodules when edit is unchecked (not view)
    if (action === "edit" && !isChecked) {
      Object.keys(updated).forEach((k) => {
        if (
          k.startsWith(baseKey) &&
          k !== key &&
          (k.includes("ops_approval") || k.includes("finance_approval"))
        ) {
          updated[k] = false;
        }
      });
    }

    // ✅ Auto-check Professional Invoice Edit when Ops or Finance Approval toggled
    if (key.includes("ops_approval_edit") || key.includes("finance_approval_edit")) {
      const parentEditKey = baseKey.replace(/_(ops|finance)_approval$/, "");
      updated[`${parentEditKey}_edit`] = true;
      updated[`${parentEditKey}_view`] = true; // ensure view also checked
    }
  
      return updated;
    });
  };
  

  const handleCreate = () => {
    console.log("Form Data:", formData)
    console.log("Permissions:", permissions)
    alert("Admin created! Check console for details.")
  }

  const permissionsData = [
    {
      module: "Common",
      items: [
        "Job Description",
        "Additional Training",
        "Cities",
        "Company Type",
        "Department Types",
        "Document Types",
        "Languages",
        "Experience",
        "Specialization",
        "Professional Registration Types",
        "Profession",
        "Qualifications",
        "Software",
        "Additional skills",
        "International Department",
        "International Experience",
      ],
    },
    {
      module: "Events",
      items: ["Events List", "Interview", "Referral"],
    },
    {
      module: "Hospital",
      items: ["Corporate", "Company", "Branch", "Department", "Rates"],
    },
    {
      module: "Locum Job",
      items: ["Application", "Locum Jobs", "Shift Logs"],
    },
    {
      module: "Permanent Job",
      items: ["Applications", "Job"],
    },
    {
      module: "Credit Limit",
      items: ["Credit Limit"],
    },
    {
      module: "Users",
      items: [
        "NurseHospital User",
        "PreSign Up User",
        "Premium User",
        "Document Verification",
        "Orwin Candidates",
      ],
    },
    {
      module: "Billing",
      items: ["Bill of Supply"],
    },
    {
      module: "Locum Invoices",
      items: [
        {
          name: "Professional Invoice",
          subItems: [
            { name: "Finance Approval", type: "approval" },
            { name: "Ops Approval", type: "approval" },
          ],
        },
        "Professional Tax Invoice",
        "Bank Details",
      ],
    },
    {
      module: "Availability",
      items: ["Availability"],
    },
    {
      module: "Rewards Engine",
      items: ["Global Settings", "Event Configuration", "Referral Levels", "Analytics"],
    },
    {
      module: "Monetization",
      items: ["Monetization MLP"],
    },
  ];
 const roleOptions=[
  {
    key:"Company",
    value:"Company"
  }
 ]


  const {
    register,
    control,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(adminUserDialogValidation),
  });

  const dispatch = useDispatch();



const handleFormSubmit = async (e) => {
  console.log("Form submit triggered");
  e.preventDefault();
  try {
    console.log("Calling handleSubmit");
    await handleSubmit(onSubmit)();
    console.log("handleSubmit completed");
  } catch (error) {
    console.error("Form submission error:", error);
  }
};
useEffect(() => {
  console.log("Form errors:", errors);
}, [errors]);

  
const getModulePayloadName = (moduleId) => {
  if (!moduleId) return moduleId;

  // Normalize and clean
  let cleaned = moduleId.toLowerCase().trim();

  // Remove prefixes (common_, billing_, etc.)
  cleaned = cleaned
    .replace(/^common_/, "")
    .replace(/^events_/, "")
    .replace(/^hospital_/, "")
    .replace(/^LocumJob_/, "")
    .replace(/^permanentJob_/, "")
    .replace(/^creditLimit_/, "")
    .replace(/^users_/, "")
    .replace(/^billing_/, "")
    .replace(/^locum_invoices_/, "")
    .replace(/^availability_/, "")
    .replace(/^rewards_engine_/, "")
    .replace(/^monetization_/, "")
    .replace(/_(view|edit|export)$/, ""); // remove action suffix if any

  // Extra normalization: remove duplicate underscores and spaces
  cleaned = cleaned.replace(/\s+/g, "_").replace(/_+/g, "_");

  // Fuzzy map
  const moduleMap = {
    // Common modules
    jobdescription: "jdRule",
    job_description: "jdRule",
    jd_rule: "jdRule",

    additionaltraining: "additionaltraining",
    additional_training: "additionaltraining",

    cities: "city",
    city: "city",

    companytype: "companyTypes",
    company_type: "companyTypes",

    departmenttype: "departmenttype",
    departmenttypes: "departmenttype",
    department_types: "departmenttype",

    documenttype: "documenttype",
    documenttypes: "documenttype",
    document_types: "documenttype",

    languages: "language",
    experience: "experience",
    specialization: "specialization",

    professionalregistrationtypes: "professionalregistrationtypes",
    professional_registration_types: "professionalregistrationtypes",
    professionalregistrationtype: "professionalregistrationtypes",

    profession: "professionalTypes",
    qualifications: "qualificationTypes",
    software: "software",
    subscription: "subscription",
    additionalskills: "skillsRoute",

    gccdepartment: "gccDepartment",
    gcc_department: "gccDepartment",
    internationaldepartment: "gccDepartment",
    international_department: "gccDepartment",

    gccexperience: "gccExperience",
    gcc_experience: "gccExperience",
    internationalexperience: "gccExperience",
    international_experience: "gccExperience",

    // Hospital modules
    corporate: "company",
    company: "organization",
    branch: "branch",
    department: "departments",
    rates: "rate",

    // Locum Job modules
    application: "application",
    locum_jobs: "job",
    locum_jobs_shift_logs: "job_shiftLogs",
    locum_jobs_shiftlogs: "job_shiftLogs",
    locum_job_shift_logs: "job_shiftLogs",
    locum_job_shiftlogs: "job_shiftLogs",

    shift_logs: "job_shiftLogs",
    shiftlogs: "job_shiftLogs",

    // Permanent Job modules
    permanent_job_applications: "permanentapplication",
    permanentjob_applications: "permanentapplication",
    applications: "permanentapplication",
    permanentapplication: "permanentapplication",
    applications: "permanentapplication",
    permanentapplication: "permanentapplication",
    job: "permanentjob",
    credit_limit: "credit_limit",

    //` Users modules
    nursehospital_user: "user",
    presign_up_user: "verification",
    premiumUser: "subscription",
    premium_user: "subscription",
    document_verification: "docVerification",
    orwin_candidates: "orwin",

    // Events modules
    events: "upcomingEvents",
    interview: "interviewslot",
    referral: "refferal",

    // Other modules
    bill_of_supply: "bill",
    professional_invoice: "professional_invoice",
    professional_tax_invoice: "invoiceTax",
    finance_approval: "finance_approval",
    ops_approval: "ops_approval",
    bank_details: "bank_details",
    availability: "availability",
    monetization_mlp: "monetization",
    global_settings: "global_settings",
    event_configuration: "event_configuration",
    referral_levels: "referral_levels",
    analytics: "analytics",
  };

  // 1️⃣ Try exact match
  if (moduleMap[cleaned]) return moduleMap[cleaned];

  // 2️⃣ Try relaxed matching — remove underscores and match base
  const base = cleaned.replace(/_/g, "");
  for (const [key, value] of Object.entries(moduleMap)) {
    const normalizedKey = key.replace(/_/g, "");
    if (base.includes(normalizedKey)) {
      return value;
    }
  }

  // 3️⃣ Log if still not matched
  console.warn(`⚠️ No mapping found for module: "${moduleId}" (cleaned: "${cleaned}")`);
  return moduleId;
};





  const getModuleKey = (moduleName) => {
    return moduleName.toLowerCase().replace(/\s+/g, '_');
  };
  const getModulePermissionKeys = (section, action) => {
    const moduleKey = section.module.toLowerCase().replace(/\s+/g, "_");
    const keys = [];
  
    section.items.forEach((item) => {
      if (typeof item === "object" && item.subItems) {
        const parentKey = item.name.toLowerCase().replace(/\s+/g, "_");
        keys.push(`${moduleKey}_${parentKey}_${action}`);
  
        item.subItems.forEach((sub) => {
          const subKey = sub.name.toLowerCase().replace(/\s+/g, "_");
          if (sub.type === "approval" && action === "edit") {
            keys.push(`${moduleKey}_${parentKey}_${subKey}_edit`);
          } else if (sub.type !== "approval") {
            keys.push(`${moduleKey}_${parentKey}_${subKey}_${action}`);
          }
        });
      } else {
        const itemKey = item.toLowerCase().replace(/\s+/g, "_");
        keys.push(`${moduleKey}_${itemKey}_${action}`);
      }
    });
  
    return keys;
  };
  const handleSelectAllModule = (section, action) => {
    const keys = getModulePermissionKeys(section, action);
  
    setPermissions((prev) => {
      const updated = { ...prev };
  
      const shouldEnable = keys.some((k) => !updated[k]);
  
      keys.forEach((key) => {
        updated[key] = shouldEnable;
  
        // Auto-check view when edit/export enabled
        if ((action === "edit" || action === "export") && shouldEnable) {
          const baseKey = key.replace(/_(edit|export)$/, "");
          updated[`${baseKey}_view`] = true;
        }
  
        // Uncheck edit/export if view disabled
        if (action === "view" && !shouldEnable) {
          updated[`${key.replace("_view", "")}_edit`] = false;
          updated[`${key.replace("_view", "")}_export`] = false;
        }
      });
  
      return updated;
    });
  };
  const isModuleFullyChecked = (section, action) => {
    const keys = getModulePermissionKeys(section, action);
    return keys.length > 0 && keys.every((k) => permissions[k]);
  };
  
    

  const onSubmit = (data) => {
    const transformedPermissions = [];
    const moduleActionMap = new Map();
    
    // Debug: Log all permissions being processed
    console.log('All permissions:', permissions);
  
    // First pass: collect all actions for each module
    Object.entries(permissions).forEach(([key, value]) => {
      if (!value) return;
    
      const parts = key.split("_");
      const action = parts.pop(); // view, edit, export
      const modulePath = parts.join("_");
   

      // 🔹 1️⃣ Handle Professional Invoice and its sub-approvals (merge under "invoice")
      if (modulePath.includes("locum_invoices_professional_invoice")) {
        const payloadModule = "invoice";
        if (!moduleActionMap.has(payloadModule)) {
          moduleActionMap.set(payloadModule, new Set());
        }
    
        const actions = moduleActionMap.get(payloadModule);
    
        // ⚠️ Critical: check specifically for approval type
        if (modulePath?.endsWith("finance_approval")) {
          actions.add("financeApprove");
        } else if (modulePath?.endsWith("ops_approval")) {
          actions.add("operationApprove");
        } else {
          actions.add(action); // for view/edit/export of parent item only
        }
    
        return;
      }
    
      // 🔹 2️⃣ Handle Professional Tax Invoice (kept separate as invoiceTax)
      if (
        modulePath.includes("locum_invoices_professional_tax_invoice") ||
        modulePath.includes("professional_invoice")
      ) {
        const payloadModule = "invoiceTax";
        if (!moduleActionMap.has(payloadModule)) {
          moduleActionMap.set(payloadModule, new Set());
        }
        moduleActionMap.get(payloadModule).add(action);
        return;
      }
    
      // 🔹 3️⃣ Document Types
      if (modulePath.includes("document_types") || modulePath.includes("document types")) {
        const payloadModule = "documenttype";
        if (!moduleActionMap.has(payloadModule)) {
          moduleActionMap.set(payloadModule, new Set());
        }
        moduleActionMap.get(payloadModule).add(action);
        return;
      }
    
      // 🔹 4️⃣ Department Types
      if (modulePath.includes("department_types")) {
        const payloadModule = "departmenttype";
        if (!moduleActionMap.has(payloadModule)) {
          moduleActionMap.set(payloadModule, new Set());
        }
        moduleActionMap.get(payloadModule).add(action);
        return;
      }
    
      // 🔹 5️⃣ Bank Details
      if (modulePath.includes("bank_details") || modulePath.includes("bank")) {
        const payloadModule = "bank";
        if (!moduleActionMap.has(payloadModule)) {
          moduleActionMap.set(payloadModule, new Set());
        }
        moduleActionMap.get(payloadModule).add(action);
        return;
      }
    
      // 🔹 6️⃣ Default mapping
      const moduleKey = getModulePayloadName(modulePath);
      if (!moduleActionMap.has(moduleKey)) {
        moduleActionMap.set(moduleKey, new Set());
      }
      moduleActionMap.get(moduleKey).add(action);
    });
    
    

    // 🧩 Debug: find unmapped module keys
const allSelectedModules = Object.keys(permissions)
.filter((key) => permissions[key] === true)
.map((key) => key.replace(/_(view|edit|export)$/, "")); // remove action suffix

const mappedModules = Array.from(moduleActionMap.keys());
const missingModules = [];

allSelectedModules.forEach((mod) => {
// If this module path didn’t get mapped in moduleActionMap
if (
  !mappedModules.some((m) =>
    mod.toLowerCase().includes(m.toLowerCase())
  )
) {
  missingModules.push(mod);
}
});

if (missingModules.length > 0) {
console.warn("⚠️ These modules were selected but not mapped in payload:", missingModules);
} else {
console.log("✅ All selected modules successfully mapped.");
}

    
    // Convert the map to the final permissions array
    moduleActionMap.forEach((actions, module) => {
      if (actions.size > 0) { // Only include modules with actions
        transformedPermissions.push({
          module,
          actions: Array.from(actions).sort()
        });
      }
    });
    
    console.log('Processed permissions:', transformedPermissions);
  
    const payload = {
      name: {
        first: data.name?.first || "",
        last: data.name?.last || "",
      },
      email: data.email || "",
      password: data.password || "",
      permissions: transformedPermissions,
      role: "Sub_Admin",
    };
  
    console.log("✅ Final Payload:", payload);
    dispatch(addAdminUser(payload));
    handleDialogClose();
  };
  
  
useEffect(() => {
    dispatch(setRoleType());
  }, []);
  const handleRoleChange=(e)=>{
   
    if(errors?.role?.message)
    errors.role.message="";
   
    setValue("role", e.target.value);
    setRole(e.target.value);
  }

  // useEffect(() => {
  //   dispatch(setRoleType());
  // }, [dispatch]);

  return (
    <Box sx={{ padding: "16px 24px", background: "#fff", borderRadius: 2 }}>
      {/* <form onSubmit={handleSubmit(onSubmit)}> */}
      <form onSubmit={handleFormSubmit}>
        <Grid container spacing={2}>
          {/* Name */}
          <Grid item xs={4}>
            <InputLabel>Name</InputLabel>
          </Grid>
          <Grid item xs={4}>
            <MDInput
              placeholder="First name"
              {...register("name.first")}
              error={!!errors?.name?.first}
              helperText={errors?.name?.first?.message}
            />
          </Grid>
          <Grid item xs={4}>
            <MDInput
              placeholder="Last name"
              {...register("name.last")}
              error={!!errors?.name?.last}
              helperText={errors?.name?.last?.message}
            />
          </Grid>

          {/* Email */}
          <Grid item xs={4}>
            <InputLabel>Email</InputLabel>
          </Grid>
          <Grid item xs={8}>
            <MDInput
              placeholder="Email"
              {...register("email")}
              error={!!errors?.email}
              helperText={errors?.email?.message}
            />
          </Grid>

          {/* Password */}
          <Grid item xs={4}>
            <InputLabel>Password</InputLabel>
          </Grid>
          <Grid item xs={4}>
            <MDInput
              placeholder="Password"
              type="password"
              {...register("password")}
              error={!!errors?.password}
              helperText={errors?.password?.message}
            />
          </Grid>
          <Grid item xs={4}>
            <MDInput
              placeholder="Confirm Password"
              type="password"
              {...register("confirmPassword")}
              error={!!errors?.confirmPassword}
              helperText={errors?.confirmPassword?.message}
            />
          </Grid>
       
        </Grid>
          <div className="permissions-section">
                      <div className="permissions-header">
                        <h3 className="permissions-title">Module Permissions</h3>
                        <p className="permissions-hint">Checking Edit or Export will auto-check View</p>
                      </div>
        
                      <div className="permissions-table-wrapper">
                        <table className="permissions-table">
                          <thead>
                            <tr className="permissions-table-header">
                              <th>Module</th>
                              <th>Item</th>
                              <th>View</th>
                              <th>Edit</th>
                              <th>Export</th>
                            </tr>
                          </thead>
                          <tbody>
  {permissionsData.map((section) => {
    const isExpanded = expandedModules[section.module];

    return (
      <React.Fragment key={section.module}>
<tr className="permissions-module-header">
  {/* MODULE NAME CELL */}
  <td
    colSpan={isExpanded ? 2 : 4}
    onClick={() => toggleModule(section.module)}
    style={{ cursor: "pointer" }}
  >
    <div className="module-title">
      {section.module}

      {/* ICON when EXPANDED → inside name cell, right aligned */}
      {isExpanded && (
        <span className="dropdown-icon end">
          ▼
        </span>
      )}
    </div>
  </td>

  {/* ICON when COLLAPSED → last column */}
  {!isExpanded && (
    <td
      colSpan={1}
      onClick={() => toggleModule(section.module)}
      className="permissions-icon-cell"
    >
      ▶
    </td>
  )}

  {/* CHECKBOXES → ONLY when expanded */}
  {isExpanded && (
    <>
      <td className="permissions-checkbox-cell">
        <input
          type="checkbox"
          checked={isModuleFullyChecked(section, "view")}
          onChange={(e) => {
            e.stopPropagation();
            handleSelectAllModule(section, "view");
          }}
        />
      </td>

      <td className="permissions-checkbox-cell">
        <input
          type="checkbox"
          checked={isModuleFullyChecked(section, "edit")}
          onChange={(e) => {
            e.stopPropagation();
            handleSelectAllModule(section, "edit");
          }}
        />
      </td>

      <td className="permissions-checkbox-cell">
        <input
          type="checkbox"
          checked={isModuleFullyChecked(section, "export")}
          onChange={(e) => {
            e.stopPropagation();
            handleSelectAllModule(section, "export");
          }}
        />
      </td>
    </>
  )}
</tr>




        {/* 🔹 MODULE CONTENT */}
        {isExpanded &&
          section.items.map((item) => {
            const moduleKey = section.module.toLowerCase().replace(/\s+/g, "_");

            // 🔸 Nested items
            if (typeof item === "object" && item.subItems) {
              const parentItemKey = item.name.toLowerCase().replace(/\s+/g, "_");

              return (
                <React.Fragment key={`${section.module}-${item.name}`}>

                  {/* Parent */}
                  <tr className="permissions-table-row parent-item-row">
                    <td></td>
                    <td className="permissions-item-cell parent-item">
                      {item.name}
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        checked={permissions[`${moduleKey}_${parentItemKey}_view`] || false}
                        onChange={() =>
                          handlePermissionChange(`${moduleKey}_${parentItemKey}_view`)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        checked={permissions[`${moduleKey}_${parentItemKey}_edit`] || false}
                        onChange={() =>
                          handlePermissionChange(`${moduleKey}_${parentItemKey}_edit`)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        checked={permissions[`${moduleKey}_${parentItemKey}_export`] || false}
                        onChange={() =>
                          handlePermissionChange(`${moduleKey}_${parentItemKey}_export`)
                        }
                      />
                    </td>
                  </tr>

                  {/* Sub-items */}
                  {item.subItems.map((subItem) => {
                    const subKey = subItem.name.toLowerCase().replace(/\s+/g, "_");
                    const fullKey = `${parentItemKey}_${subKey}`;

                    return (
                      <tr key={fullKey} className="permissions-table-row sub-item-row">
                        <td></td>
                        <td className="permissions-item-cell sub-item">
                          — {subItem.name}
                        </td>

                        <td></td>
                        <td>
                          <input
                            type="checkbox"
                            checked={permissions[`${moduleKey}_${fullKey}_edit`] || false}
                            onChange={() =>
                              handlePermissionChange(`${moduleKey}_${fullKey}_edit`)
                            }
                          />
                        </td>
                        <td></td>
                      </tr>
                    );
                  })}
                </React.Fragment>
              );
            }

            // 🔸 Regular item
            const itemKey = item.toLowerCase().replace(/\s+/g, "_");

            return (
              <tr key={`${section.module}-${item}`} className="permissions-table-row">
                <td></td>
                <td className="permissions-item-cell">{item}</td>
                <td>
                  <input
                    type="checkbox"
                    checked={permissions[`${moduleKey}_${itemKey}_view`] || false}
                    onChange={() =>
                      handlePermissionChange(`${moduleKey}_${itemKey}_view`)
                    }
                  />
                </td>
                <td>
                  <input
                    type="checkbox"
                    checked={permissions[`${moduleKey}_${itemKey}_edit`] || false}
                    onChange={() =>
                      handlePermissionChange(`${moduleKey}_${itemKey}_edit`)
                    }
                  />
                </td>
                <td>
                  <input
                    type="checkbox"
                    checked={permissions[`${moduleKey}_${itemKey}_export`] || false}
                    onChange={() =>
                      handlePermissionChange(`${moduleKey}_${itemKey}_export`)
                    }
                  />
                </td>
              </tr>
            );
          })}
      </React.Fragment>
    );
  })}
</tbody>

                        </table>
                      </div>
                    </div>
        

        {/* ✅ Fixed footer buttons */}
       <div className="permissions-footer">
          <MDButton
             variant="contained"
    color="info"
          type="submit"
          sx={{ marginTop: "1.5rem" }}
          >
          create
          </MDButton>
     <MDButton
  variant="outlined"
  color="secondary"
  onClick={handleDialogClose} // 👈 optional — closes the dialog
  sx={{
    marginTop: "1.5rem",
    borderColor: "#9e9e9e",
    color: "#555",
    backgroundColor: "#f5f5f5",
    "&:hover": {
      backgroundColor: "#e0e0e0",
    },
  }}
>
  Cancel
</MDButton>
      </div>
      </form>
    </Box>
  );
};

export default AddAdminUserDialogContent;
